module.exports = __webpack_public_path__ + "static/media/private-labelling.7889401e.jpg";